<template>
  <vs-row class="flex w-auto mr-4" vs-align="center" :class="size==='mobile' ? 'layout-mobile' : ''" >
    <vs-col class="w-auto mr-4">{{ label }}</vs-col>
    <vs-col class="w-auto">
      <project-selector :class="size" :size="size" :use-name="useName" v-model="projectId" @select="select"/>
    </vs-col>
  </vs-row>
</template>

<script>
import ProjectSelector from '@/components/selector/ProjectSelector'
export default {
  name: 'SearchNavItemProject',
  components: {ProjectSelector},
  props: {
    label: String,
    value: {
      type:[String, Number],
      defalut:''
    },
    size: {
      type: String,
      default: 'normal'
    },
    useName: Boolean
  },
  watch: {
    value (value) {
      this.projectId = value
    }
  },
  data () {
    return {
      projectId: ''
    }
  },
  methods: {
    changeText () {
      this.$emit('input', this.projectId)
    },

    keyupEvent (event) {
      if (event.code === 'NumpadEnter' || event.code === 'Enter') {
        this.$emit('keyupEvent', event.target.value)
      }
    },
    select (project) {
      this.$emit('input', this.projectId)
      this.$emit('select', project)
    }

  }
}
</script>

<style scoped>

.layout-mobile {
  display: grid !important;
  grid-template-columns: 70px 1fr;
  margin:0 0 1rem 0 !important;
}
.mobile {
  width:100% !important;
}

.small {
  width: 100px;
}

.normal {
  width: 130px;
}

.big {
  width: 160px;
}

.auto {
  width: auto;
}
</style>
